// extracted by mini-css-extract-plugin
export var childClients = "ClientCard-module--childClients--ab30c";
export var childClientsWrapper = "ClientCard-module--childClientsWrapper--b6ed9";
export var childLogo = "ClientCard-module--childLogo--e014f";
export var childLogoWrapper = "ClientCard-module--childLogoWrapper--8cf46";
export var description = "ClientCard-module--description--9163c";
export var logo = "ClientCard-module--logo--387fd";